$(document).on("turbolinks:load", () => {
  $(".select2-data").select2()
})
